import React from 'react';

import {
  Colors,
} from '@noitada/shared/constants';

import {
  DayView,
  DayItem,
  DateItem,
  YearItem,
} from './styled';



export interface IProps {
  selected?: boolean;

  // Date to render
  date: Date;

  // Size text
  size?: number;
}



const DateViewCalendar: React.FC<IProps> = (props: IProps) => {
  const date = props.date;
  const colorText = props.selected ? Colors.white : Colors.white;


  const weekday = [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ];


  function convertToDate() {
    let dd: any = date.getDate();
    let mm: any = date.getMonth() + 1; // Months start at 0!

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const formattedToday = dd + '/' + mm;
    return formattedToday;
  }



  return (

    <DayView>

      <DayItem
        selected={props.selected}
        color={colorText}>
        {weekday[date.getDay()]}
      </DayItem>


      <DateItem
        selected={props.selected}
        color={colorText}>
        {convertToDate()}
      </DateItem>


      <YearItem
        selected={props.selected}
        color={colorText}>
        {date.getFullYear()}
      </YearItem>

    </DayView>

  );
};



export default DateViewCalendar;
